module.exports = __webpack_public_path__ + "media/G.c56f8152.mp3";